import React from "react";
import { useParams } from "react-router-dom";
import IncSiteForm from "./inc_site_form";

const EditIncSite: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  return <IncSiteForm mode="edit" siteId={id} />;
};

export default EditIncSite;
